import { FC } from 'external/react'
import LabeledValue from 'components/LabeledValue'
import CourseCover from 'components/CourseCover'

import PackageEditCourse, {PackageSelectComplementaryCourse} from './PackageEditCourse'
import PackageWorkbookSwitch from './PackageWorkbookSwitch'
import { Course } from '../../types/course'


type PackageCourseProps = {
    course: Course
}

const PackageCourse : FC<PackageCourseProps>  = props => {
    const {course} = props
    const {courseId, courseName, subjectName, gradeName, workbook, extraCourse} = course

    return (
        <div className='row d-flex justify-content-center align-items-center h-100'>
            <div className='card mb-2' style={{ borderRadius: '10px' }}>
                <div className='card-body px-0'>
                    <div className='d-flex text-black'>
                        <div className='flex-shrink-0'>
                            <CourseCover className='img-fluid' style={{ width: '90px', borderRadius: '10px', "border": "outset 1px #cacacaff" }} id={courseId} name={courseName} />
                       </div>
                        <div className='flex-grow-1 ms-3' style={{ textAlign: 'left' }}>
                            <LabeledValue label='Materia' value={subjectName} />
                            <LabeledValue label='Curso' value={courseName} />
                            <LabeledValue label='Grado' value={gradeName} />
                           <div
                                className='d-flex justify-content-between'
                                style={{
                                    alignItems: 'center',
                                }}
                            >
                               {workbook && <PackageWorkbookSwitch course={course} />}
                               <PackageEditCourse course={course} extra={false} />
                           </div>
                        </div>
                    </div>
                    {course.type === 'basic' && (
                        <div className='extra-card px-0'>
                            <div className='d-flex flex-column text-black mt-3 pt-2' style={{"borderTop": "solid 1px #dee2e6"}}>
                            <div className='extra-label d-flex justify-content-start' style={{fontSize: '1.15rem'}}>Curso complementario</div>
                            {!course.extraCourse.course && (
                                <div className='flex-shrink-0 d-flex'>
                                    <PackageSelectComplementaryCourse course={course} extra={true} />
                               </div>

                            )}
                            {course.extraCourse.course && (
                            <div className='extra-course d-flex p-2'>
                                <div className='flex-shrink-0'>
                                    <CourseCover className='img-fluid' style={{ width: '90px', borderRadius: '10px', "border": "outset 1px #cacacaff" }} id={extraCourse.course} name={extraCourse.name_course} />
                               </div>
                                <div className='flex-grow-1 ms-3' style={{ textAlign: 'left' }}>
                                    <LabeledValue label='Curso' value={extraCourse.name_course} />
                                    <LabeledValue label='Grado' value={extraCourse.gradeName[extraCourse.language]} />
                                   <div
                                        className='d-flex justify-content-end'
                                        style={{
                                            alignItems: 'center',
                                        }}
                                    >
                                       <PackageEditCourse course={course} extra={true} />
                                   </div>
                                </div>
                            </div>
                            )}
                        </div>
                        </div>
                    )}


                </div>
            </div>
        </div>
    )
}

export {PackageCourse as default}